module.exports = __webpack_public_path__ + "static/img/h3-1.3023ece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd128/h3-1.png
// module id = /Efc
// module chunks = 1